import React, { useState, Component } from 'react';
import { AnimatedSection } from './AnimatedSection';
import { motion, AnimatePresence } from 'framer-motion';
import { Scissors, Droplets, Sparkles, Scroll, Wrench, Wind } from 'lucide-react';
import { useLanguage } from './LanguageContext';
const categories = [{
  id: 'shaving',
  name: 'SHAVING & GROOMING',
  icon: Scissors,
  products: [{
    name: 'Elegance Shaving Gel Jupiter 2L',
    price: '$15.00'
  }, {
    name: 'Elegance Shaving Gel Venus 2L',
    price: '$15.00'
  }, {
    name: 'Elegance Shaving Gel Earth 2L',
    price: '$15.00'
  }, {
    name: 'Rolda Midnight Ginseng Shaving Gel',
    price: '$15.00'
  }, {
    name: 'Rolda Menthol & Mint Shaving Cream',
    price: '$15.00'
  }, {
    name: 'Rolda Multi-Vitamin Shave Gel',
    price: '$15.00'
  }, {
    name: 'Rolda Shave Gel Cooling Effect',
    price: '$15.00'
  }, {
    name: 'Nishman 01 Energizing Shaving Gel',
    price: 'From $6.99'
  }, {
    name: 'Nishman 08 Gold Shaving Gel',
    price: 'From $6.99'
  }, {
    name: 'Nishman Fresh Active 03 Shaving Gel',
    price: 'From $6.99'
  }, {
    name: 'Pro Shave Brushless Shaving Cream',
    price: 'From $10.00'
  }, {
    name: 'Clubman Shave Butter 6 Oz',
    price: '$11.99'
  }]
}, {
  id: 'beard',
  name: 'BEARD & BODY CARE',
  icon: Droplets,
  products: [{
    name: 'Clubman 2 in 1 Beard Conditioner 3 Oz',
    price: '$6.99'
  }, {
    name: 'Clubman Beard & Body Wash 14.5 Oz',
    price: '$11.99'
  }, {
    name: 'Agadir Invisible Shaving Gel 16 Oz',
    price: '$12.00'
  }, {
    name: 'Agadir Men Invisible Shave Gel 6 Oz',
    price: '$6.99'
  }, {
    name: 'MySalon For Men Shower & Go Shampoo 18.3 Oz',
    price: '$5.00'
  }]
}, {
  id: 'cleansing',
  name: 'CLEANSING & SKIN',
  icon: Sparkles,
  products: [{
    name: 'Noxzema Eucalyptus Moisturizing Cream 12 Oz',
    price: '$6.75'
  }, {
    name: 'Lucky Tiger Vanishing Cream 12 Oz',
    price: '$9.99'
  }, {
    name: 'Lucky Tiger Molle Shave Cream 12 Oz',
    price: '$9.99'
  }]
}, {
  id: 'neck',
  name: 'NECK STRIPS & ACCESSORIES',
  icon: Scroll,
  products: [{
    name: 'Sanek Neck Strips',
    price: '$12.00'
  }, {
    name: 'L3VEL3 White Neck Strips 5-Pack',
    price: '$12.99'
  }, {
    name: 'L3VEL3 Black Neck Strips 5-Pack',
    price: '$12.99'
  }, {
    name: 'L3VEL3 Red Neck Strips 5-Pack',
    price: '$12.99'
  }, {
    name: 'Nishman Barber Neck Strips 5 Pack',
    price: '$10.00'
  }, {
    name: 'JRL Black Neck Strips 5 Pack',
    price: '$12.00'
  }, {
    name: 'Nishman Neck Strip Dispenser',
    price: '$6.99'
  }, {
    name: 'Round Roll Neck Strip Rolls 5 Pack',
    price: '$8.00'
  }]
}, {
  id: 'tools',
  name: 'TOOLS & EQUIPMENT',
  icon: Wrench,
  products: [{
    name: 'Stylecraft Studio Corded Blower',
    price: '$59.95'
  }, {
    name: 'PST Towels',
    price: '$6.00'
  }]
}, {
  id: 'fragrances',
  name: 'FRAGANCIAS',
  icon: Wind,
  products: [{
    name: 'Immortal NYC 03 Reserve Eau de Cologne',
    price: '$17.99'
  }]
}];
export function Products() {
  const {
    t
  } = useLanguage();
  const [activeTab, setActiveTab] = useState(categories[0].id);
  return <AnimatedSection id="productos" className="bg-barber-dark/30" data-id="element-163">
      <div className="text-center mb-12" data-id="element-164">
        <h2 className="text-4xl md:text-5xl font-oswald font-bold mb-4" data-id="element-165">
          {t.products.title}
        </h2>
        <p className="text-xl text-barber-gold font-medium" data-id="element-166">
          {t.products.subtitle}
        </p>
      </div>

      <div className="flex flex-col lg:flex-row gap-8 max-w-6xl mx-auto" data-id="element-167">
        {/* Categories Sidebar */}
        <div className="lg:w-1/3 flex flex-col gap-2" data-id="element-168">
          {categories.map(category => {
          const Icon = category.icon;
          const isActive = activeTab === category.id;
          return <button key={category.id} onClick={() => setActiveTab(category.id)} className={`flex items-center gap-3 p-4 rounded-lg text-left transition-all duration-200 ${isActive ? 'bg-barber-gold text-barber-black font-bold' : 'bg-barber-dark text-gray-300 hover:bg-barber-dark/80 hover:text-white border border-white/5'}`} data-id="element-169">
                <Icon size={20} className={isActive ? 'text-barber-black' : 'text-barber-gold'} data-id="element-170" />
                <span className="font-oswald tracking-wide" data-id="element-171">
                  {category.name}
                </span>
              </button>;
        })}
        </div>

        {/* Products Grid */}
        <div className="lg:w-2/3" data-id="element-172">
          <AnimatePresence mode="wait" data-id="element-173">
            {categories.map(category => category.id === activeTab && <motion.div key={category.id} initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.3
          }} className="grid sm:grid-cols-2 gap-4" data-id="element-174">
                    {category.products.map((product, idx) => <a key={idx} href={`https://wa.me/17185824903?text=${encodeURIComponent(`Hola, me interesa ordenar: ${product.name} (${product.price})`)}`} target="_blank" rel="noopener noreferrer" className="bg-barber-dark p-5 rounded-lg border border-white/5 flex flex-col justify-between hover:border-barber-gold/40 cursor-pointer transition-colors group" data-id="element-175">
                        <h4 className="font-medium text-gray-200 mb-4 leading-snug group-hover:text-white transition-colors" data-id="element-176">
                          {product.name}
                        </h4>
                        <div className="flex items-center justify-between" data-id="element-177">
                          <span className="text-barber-gold font-oswald text-xl font-bold" data-id="element-178">
                            {product.price}
                          </span>
                          <span className="text-xs text-gray-500 group-hover:text-barber-gold transition-colors font-oswald uppercase tracking-wider" data-id="element-179">
                            Ordenar →
                          </span>
                        </div>
                      </a>)}
                  </motion.div>)}
          </AnimatePresence>
        </div>
      </div>
    </AnimatedSection>;
}